import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { Settings } from 'luxon';
import { initReactI18next } from 'react-i18next';
import resources from 'virtual:i18next-loader';

Settings.defaultLocale = 'nl';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: 'nl',
        lng: localStorage.getItem('i18nextLng') || 'nl',
        supportedLngs: ['de', 'en', 'fr', 'nl'],
        resources,
        ns: [
            'ai',
            'changelist',
            'documents',
            'global',
            'labels',
            'publications',
            'reimbursements',
            'translations',
            'users',
            'media',
            'forms',
        ],
        defaultNS: 'global',
    });

export default i18n;
